export class ChangeLangModel {
    lang: string;
}
